























































































































































































































































































































































































































































import { Component, Watch } from "vue-property-decorator";
import { User } from "@/models/user-model";
import { ErrorBag, Validator } from "vee-validate";
import router from "../../router";
import BtFormGroup from "../../components/BtFormGroup.vue";
import { BtChoserType } from "@/components/bt-choser/bt-choser-models";
import BtChoser from "../../components/bt-choser/BtChoser.vue";
import {
  arrayToSelect2,
  confirmAction,
  confirmDeletion,
  GlobalHelper,
} from "@/helper/global-helper";
import { UserService } from "@/services/user-service";
import { Kunde } from "@/models/kunde-model";
import { KundeService } from "@/services/kunde-service";
import EditPageBase from "@/views/Generic/EditPageBase.vue";
import { LookupModule, LookupStore } from "@/store/modules/lookup-store";
import { UserModule, UserStore } from "@/store/modules/currentuser-store";
import {
  Berechtigung,
  EffektiveBerechtigung,
  lookup_Berechtigung,
} from "@/lib";
import UserNameDisplay from "@/components/UserNameDisplay.vue";

@Component({
  components: { BtFormGroup, BtChoser, UserNameDisplay },
})
export default class UserEdit extends EditPageBase {
  private userService!: UserService;
  private kundeService!: KundeService;
  public BtChoserType: any = BtChoserType;
  public user: User = new User();
  public errors!: ErrorBag;
  public lookupStore: LookupModule = LookupStore;
  public userStore: UserModule = UserStore;

  public $validator!: Validator;
  private loading: boolean = true;
  private sending: boolean = false;
  private kundeList: Kunde[] = [];
  private kundeId: number = 0;

  private tis_true = true;

  private lizenzkunde: boolean = false;
  private kunden_admin = false;
  private allgemeine_Berechtigungen: Record<string, true> = {};
  private kunden_Berechtigungen: Record<string, Record<string, true>> = {};

  async created() {
    this.userService = new UserService();
    this.kundeService = new KundeService();
  }

  async mounted() {
    let id: number = (<any>this.$route.params).id;

    if (this.fromKundeEdit) {
      this.kundeId = id;
      this.user.KundeId = id;
      id = 0;
    }

    if (id != 0) {
      this.user = await this.userService.GetById(id);
      this.kundeId = this.user.KundeId;
    }

    this.kundeList = await this.kundeService.GetList();

    this.kunden_admin = this.hat_Berechtigung(
      "Zugriff_Kundenselbstadministration"
    );

    if (this.kunden_admin) {
      const kid = this.$store.state.user.currentUser.KundeId;
      const kun = this.kundeList.filter(({ Id }) => Id == kid)[0];
      if (kun) this.lizenzkunde = kun.IstLizenzKunde;
      this.kundeId = kid;

      if (id == 0) {
        this.user.KundeId = kid;
      }
    } else {
      this.lizenzkunde = this.userStore.currentKunde.IstLizenzKunde;
      if (!this.fromKundeEdit) {
        if (id == 0) {
          this.kundeId = this.userStore.currentKunde.Id;
          this.user.KundeId = this.kundeId;
        }
      }
    }

    this.allgemeine_Berechtigungen = {};
    this.kunden_Berechtigungen = {};

    if (this.opadmin && id != 0) {
      for (const src of this.user.EffektiveBerechtigungen) {
        const s = src as any;
        if (!s.kunde_id) {
          this.allgemeine_Berechtigungen[
            lookup_Berechtigung[s.uuid] || s.uuid
          ] = true;
        } else {
          if (!this.kunden_Berechtigungen[s.kunde_id as string]) {
            this.kunden_Berechtigungen[s.kunde_id as string] = {};
          }
          this.kunden_Berechtigungen[s.kunde_id as string][
            lookup_Berechtigung[s.uuid] || s.uuid
          ] = true;
        }
      }
    }

    this.loading = false;

    this.on_kunde();

    await this.$nextTick();
    this.enableWatch("user");
  }

  get fromKundeEdit() {
    return <any>this.$route.name == "kunde-benutzer-add";
  }

  get backRoute() {
    if (this.$route.path.startsWith("/verwaltung/benutzer"))
      return "/verwaltung/benutzer";
    if (this.fromKundeEdit) {
      return "/kunde/edit/" + this.currentKundeId;
    } else {
      return "/administration/benutzer";
    }
  }

  get currentKundeId() {
    return this.kundeId;
  }

  get currentKunde() {
    //@ts-ignore
    return this.kundeList.find((x) => x.Id == this.currentKundeId);
  }

  get kein_Nutzer(): boolean {
    return !this.user.Rolle_Nutzer_Dokumentation;
  }

  get implizit_DSB(): boolean {
    return this.user.Rolle_Rechte_eines_Datenschutzbeauftragten;
  }

  get opadmin(): boolean {
    return this.hat_Berechtigung("Zugriff_betriebliche_Administration");
  }

  @Watch("user.Rolle_Nutzer_Dokumentation")
  on_user1() {
    if (!this.user.Rolle_Nutzer_Dokumentation) {
      this.user.Rolle_Administrative_Rechte = false;
      this.user.Rolle_Rechte_eines_Datenschutzbeauftragten = false;
    }
  }

  @Watch("user.Rolle_Rechte_eines_Datenschutzbeauftragten")
  on_user2() {
    if (this.user.Rolle_Rechte_eines_Datenschutzbeauftragten) {
      this.user.Rolle_Bearbeiter_Beschwerdemanagement = false;
    }
  }

  @Watch("kundeId")
  on_kunde() {
    if (this.kunden_admin) {
      if (this.kundeId != this.$store.state.user.currentUser.KundeId) {
        this.kundeId = this.$store.state.user.currentUser.KundeId;
      }
      this.user.KundeId = this.$store.state.user.currentUser.KundeId;
      return;
    }
    if (!this.user.KundeId) {
      this.lizenzkunde = false;
    } else {
      const kunde = this.kundeList.find((x) => x.Id == this.user.KundeId);
      this.lizenzkunde = kunde ? kunde.IstLizenzKunde : false;
    }
  }

  get userKunde(): Kunde | undefined {
    return this.kundeList.find((x) => x.Id == this.user.KundeId);
  }

  get currentKundeName() {
    if (this.userKunde) return this.userKunde.Firma;
    if (
      !this.currentKundeId ||
      !this.kundeList ||
      !this.kundeList.find((x) => x.Id == this.currentKundeId)
    ) {
      return "";
    }

    //@ts-ignore
    return this.kundeList.find((x) => x.Id == this.currentKundeId).Firma;
  }

  get kundeSelect() {
    return arrayToSelect2(this.kundeList, "Id", "Firma");
  }

  async deleteUser() {
    confirmDeletion(
      this.$t("Nutzer.Nutzer löschen"),
      this.$t("Nutzer.Wollen Sie diesen Nutzer wirklich löschen?"),
      this.$t("Nutzer.Nutzer löschen"),
      this.$t("Abbrechen"),
      async () => {
        await this.userService.Delete(this.user);
        this.$router.push(this.backRoute);
      },
      () => {}
    );
  }

  async resendInvitation() {
    try {
      this.sending = true;
      await this.userService.ResendInvitation(this.user);
      GlobalHelper.NotifySuccess(this.$t("Benutzer.Einladung gesendet"));
      this.user = await this.userService.GetById(this.user.Id);
    } catch (e) {
      console.log(e);
    } finally {
      this.sending = false;
    }
  }

  async removeOTP() {
    confirmDeletion(
      this.$t("Benutzer.OTP deaktivieren"),
      this.$t("Benutzer.OTP deaktivieren-confirm"),
      this.$t("Benutzer.OTP deaktivieren"),
      this.$t("Abbrechen"),
      async () => {
        try {
          this.sending = true;
          await this.userService.RemoveOTP(this.user);
          GlobalHelper.NotifySuccess(this.$t("Benutzer.OTP deaktiviert"));
          this.user = await this.userService.GetById(this.user.Id);
        } catch (e) {
          console.log(e);
        } finally {
          this.sending = false;
        }
      },
      () => {}
    );
  }

  async checkSave(event: any) {
    event.preventDefault();
    await this.$validator.validateAll();
    if (this.errors.count() != 0) {
      GlobalHelper.NotifyError(
        this.$t("Allgemein.Pflichtfeld nicht ausgefüllt.").toString()
      );
    } else {
      let emailField = this.$validator.fields.items.find(
        (x) => x.name === "Benutzer.Email"
      );
      if (emailField) {
        if (this.user.Id != 0 && (emailField.flags as any).changed == true) {
          confirmAction(
            this.$t("Nutzer.E-Mail Adresse geändert"),
            this.$t("Nutzer.Nachfrage E-Mail Adresse geändert", {
              email: emailField.value,
            }),
            this.$t("Fortfahren"),
            this.$t("Abbrechen"),
            async () => {
              await this.save(event);
            },
            () => {
              return;
            }
          );
        } else {
          await this.save(event);
        }
      }
    }
  }

  async save(event: any) {
    try {
      this.disableWatch();
      this.sending = true;

      let message = "";

      if (this.user.Id == 0) {
        let user = await this.userService.Post(this.user);
        if (user.MitarbeiterAlreadyExists) {
          message = this.$t(
            "Nutzer.Hinweistext Mitarbeiter existiert bereits"
          ).toString();
          GlobalHelper.NotifySuccess(message, 10000);
        }
      } else {
        await this.userService.Put(this.user);
        GlobalHelper.NotifySuccess(message);
      }
      this.dirty = false;

      router.push(this.backRoute);
    } catch (e) {
      console.log(e);
    } finally {
      this.sending = false;
    }
  }

  get zugriffsbeschraenkungen_anzeigen(): boolean {
    if (!this.userKunde) return false;
    if (
      !this.userKunde.ZusatzfunktionNutzerBerechtigungAbteilung &&
      !this.userKunde.ZusatzfunktionNutzerBerechtigungKonzerngesellschaft
    )
      return false;

    // Das Wissen, welche Rollen beschraenkt sind, ist hier dupliziert, da direkt auf die ungespeicherte Rollenaenderung reagiert werden muss...
    if (this.user.Rolle_ICS_Berater) return false;
    if (this.user.Rolle_ICS_Administrator) return false;
    if (this.user.Rolle_Rechte_eines_Datenschutzbeauftragten) return false;
    if (this.user.Rolle_Administrative_Rechte) return false;
    if (!this.user.Rolle_Nutzer_Dokumentation) return false;
    return true;
  }
}
